import AppContext from '@/context';

import { inject } from 'vue'

export function useAppContext():AppContext{

    return inject<AppContext>('C')!; //'C' for 'context'
}